import { render, staticRenderFns } from "./VipButton.vue?vue&type=template&id=7d90d9ce&"
import script from "./VipButton.vue?vue&type=script&lang=ts&"
export * from "./VipButton.vue?vue&type=script&lang=ts&"
import style0 from "./VipButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports